export default "__VITE_ASSET__Dg7w0_Xn__"